import React, { useEffect } from 'react';
import {
  DefaultHero,
  Partnerships,
  SimpleCard,
  SectionRotate,
  CardBanner,
  FeatureRTBs,
  TabsCard,
  Assessments,
} from '@stone-payments/odin-legacy-pagarme/unstyled';

import HeroImage from '../images/Home/Hero.png';
import ImageABF from '../images/Home/imageABF.png';
import Card1Desktop from '../images/Home/card1-desktop.png';
import Card1Tablet from '../images/Home/card1-tablet.png';
import Card2Desktop from '../images/Home/card2-desktop.png';
import Card2Tablet from '../images/Home/card2-tablet.png';
import Card2Mobile from '../images/Home/card2-mobile.png';
import SellsRealTime from '../images/Home/sells_real_time.png';
import Compliance from '../images/Home/Compliance.png';
import Antifraude from '../images/Home/Pagarme_Antifraude.png';
import Dashboard from '../images/Home/Pagarme_Dashboard.png';
import Humanity from '../images/Home/Humanity.png';
import DigitalPayment from '../images/Home/digital_payment.png';
import PagarmeIntegracao from '../images/Home/Pagarme_Integracao.png';

import Seo from '../components/Seo';
import Layout from '../components/Layout';
import { useAnalyticsEvents } from '../hooks/useAnalyticsEvent';
import CompanyAlipay from '../images/Home/partners/company-alipay.svg';
import CompanyCasaEVideo from '../images/Home/partners/company-casa-e-video.svg';
import CompanyPolishop from '../images/Home/partners/company-polishop.svg';
import CompanyLeroyMerlin from '../images/Home/partners/company-leroy-merlin.svg';
import CompanyUsaflex from '../images/Home/partners/company-usaflex.svg';

const Home = () => {
  const partnerships = [
    {
      mobile: {
        alternativeText: 'Alipay',
        width: 79,
        height: 33,
        path: CompanyAlipay,
      },
      tablet: {
        alternativeText: 'Alipay',
        width: 79,
        height: 33,
        path: CompanyAlipay,
      },
      web: {
        alternativeText: 'Alipay',
        width: 96,
        height: 40,
        path: CompanyAlipay,
      },
    },
    {
      mobile: {
        alternativeText: 'Casa e vídeo',
        width: 133,
        height: 40,
        path: CompanyCasaEVideo,
      },
      tablet: {
        alternativeText: 'Casa e vídeo',
        width: 133,
        height: 40,
        path: CompanyCasaEVideo,
      },
      web: {
        alternativeText: 'Casa e vídeo',
        width: 166,
        height: 50,
        path: CompanyCasaEVideo,
      },
    },
    {
      mobile: {
        alternativeText: 'Leroy Merlin',
        width: 68,
        height: 100,
        path: CompanyLeroyMerlin,
      },
      tablet: {
        alternativeText: 'Leroy Merlin',
        width: 68,
        height: 100,
        path: CompanyLeroyMerlin,
      },
      web: {
        alternativeText: 'Leroy Merlin',
        width: 80,
        height: 116,
        path: CompanyLeroyMerlin,
      },
    },
    {
      mobile: {
        alternativeText: 'Polishop',
        width: 102,
        height: 33,
        path: CompanyPolishop,
      },
      tablet: {
        alternativeText: 'Polishop',
        width: 102,
        height: 33,
        path: CompanyPolishop,
      },
      web: {
        alternativeText: 'Polishop',
        width: 113,
        height: 40,
        path: CompanyPolishop,
      },
    },
    {
      mobile: {
        alternativeText: 'Usaflex',
        width: 113,
        height: 70,
        path: CompanyUsaflex,
      },
      tablet: {
        alternativeText: 'Usaflex',
        width: 113,
        height: 70,
        path: CompanyUsaflex,
      },
      web: {
        alternativeText: 'Usaflex',
        width: 113,
        height: 70,
        path: CompanyUsaflex,
      },
    },
  ];

  const { sendEvent } = useAnalyticsEvents();

  useEffect(() => {
    sendEvent({
      label: '',
      entity: 'page',
      name: 'Page view pagarme',
      description: 'Evento disparado na visualização da tela',
      deduplicate: false,
    });
  }, []);

  return (
    <Layout className="normalizer [&_a>span]:font-bold">
      <Seo
        title="Solução Completa para Pagamentos Online | Pagar.me"
        description="No Pagar.me conectamos sites e aplicativos a toda a cadeia de pagamentos para você vender online. Clique e Confira!"
        ogDescription="No Pagar.me, conectamos milhares de sites e aplicativos a toda a cadeia de pagamentos. "
      />
      <DefaultHero
        title="Pagamentos digitais para todo tipo de negócio"
        description="O Pagar.me é a tecnologia da Stone para quem vende online. De soluções prontas a APIs robustas, oferecemos tudo o que você precisa para escalar seu negócio."
        background="bg-stone-500"
        isWhiteText
        buttons={[
          {
            children: 'Cadastre-se',
            linkHref: '/ofertas',
            className: 'bg-stone-900',
          },
        ]}
        className={`
          pt-24 md:pt-0 [&_#container-defaulthero]:md:flex-row[&_#title-defaulthero>b]:text-stone-500
          [&_#description-defaulthero]:lg:text-lg [&_#description-defaulthero]:md:text-left
          [&_picture>img]:object-contain [&_picture>img]:w-full
          [&_picture>img]:max-xs:px-24 [&_picture>img]:max-lg:pr-24
        `}
        imageBorder="full"
        images={{
          mobile: {
            alternativeText: 'Imagem de exemplo',
            path: HeroImage,
          },
          tablet: {
            alternativeText: 'Imagem de exemplo',
            path: HeroImage,
          },
          web: {
            alternativeText: 'Imagem de exemplo',
            path: HeroImage,
          },
        }}
      />
      <div className="[&>div>div>h2]:lg:text-3xl [&>div>div]:py-80 [&>div>div>div]:max-sm:gap-5 [&>div>div>div]:max-md:justify-evenly ">
        <Partnerships title="O parceiro ideal para todos os tamanhos e modelos de negócio." partners={partnerships} />
      </div>
      <div className="px-[24px] flex flex-col items-center py-40 lg:py-80 [&>section>div]:grid [&>section>div]:md:grid-cols-4 [&>section>div>div]:md:col-[span_2] [&>section>div>div:last-child]:md:col-end-4  [&>section>div>div]:xl:col-[span_1] [&>section>div>div:last-child]:xl:col-end-auto [&>section>div]:xl:grid-cols-5 [&>section>div]:md:max-w-[1280px] [&>section>div>div]:rounded-2xl">
        <h2 className="font-display text-4xl font-bold leading-[38px] lg:leading-9 text-center m-0 p-0">
          Plataforma de pagamento completa para sua empresa
        </h2>

        <FeatureRTBs
          backgroundColor="bg-display-0 px-0 pb-0 pt-24 [&_#container-featureRTBs]:gap-24 md:pb-0 md:pt-40"
          cardBackgroundColor="bg-display-100 [&>p:nth-of-type(1)]:md:text-lg [&>p:nth-of-type(1)]:font-display"
          cards={[
            {
              title: 'Pagamentos otimizados',
              description: 'Checkout intuitivo, Pix, recorrência e Split para você vender mais',
              icon: 'PagarmeDolar',
            },
            {
              title: 'Fácil integração',
              description: 'Conecte o Pagar.me diretamente à sua plataforma ou implemente via API',
              icon: 'PagarmeSettings',
            },
            {
              title: 'Segurança e estabilidade',
              description: 'Proteja suas vendas com infraestrutura PCI Compliance, antifraude e alta estabilidade',
              icon: 'PagarmeGuard',
            },
            {
              title: 'Gestão transparente',
              description: 'Acompanhe suas vendas, saldos e repasses em um só lugar',
              icon: 'PagarmeReceip2',
            },
            {
              title: 'Atendimento humano',
              description: 'Fale com um especialista que entende do seu negócio, em segundos',
              icon: 'PagarmeUser',
            },
          ]}
        />
      </div>
      <SimpleCard
        title="Potencialize suas conversões"
        description="Garanta uma alta conversão de vendas para o seu negócio, com mais praticidade, rapidez e segurança para seus clientes."
        backgroundColor="[&>div>div>div]:lg:mt-24 [&>div:nth-of-type(2)]:md:w-[357px] [&>div:nth-of-type(2)>p]:md:w-[357px] [&>div:nth-of-type(2)]:md:w-full [&>div:nth-of-type(2)>p]:md:w-full"
        iconDescriptions={[
          {
            description: 'Cartão, Pix, boleto e carteiras digitais',
            text: 'Aceite as principais formas de pagamento online',
            iconName: 'PagarmeMoney',
            classNameDescription: 'font-bold mb-4 !font-display',
          },
          {
            description: 'Melhor experiência de checkout',
            text: 'Processo responsivo e seguro, que não redireciona o usuário',
            iconName: 'PagarmeComputer',
            classNameDescription: 'font-bold mb-4 !font-display',
          },
          {
            description: 'One-Click Buy e recorrência',
            text: 'Salve os cartões dos seus clientes para compras e assinaturas',
            iconName: 'PagarmeMouse',
            classNameDescription: 'font-bold mb-4 !font-display',
          },
          {
            description: 'Links de Pagamento personalizados',
            text: 'Venda nas redes sociais e recupere carrinhos abandonados',
            iconName: 'PagarmeReceip2',
            classNameDescription: 'font-bold mb-4 !font-display',
          },
          {
            description: 'Split de Pagamento customizável',
            text: 'Automatize a divisão e o repasse de pagamentos entre recebedores',
            iconName: 'PagarmeReceip',
            classNameDescription: 'font-bold mb-4 !font-display',
          },
        ]}
        image={{
          alternativeText: 'Imagem ABF',
          path: ImageABF,
        }}
        buttons={[
          {
            children: 'Quero vender mais',
            variant: 'primary',
            linkHref: '/ofertas',
          },
        ]}
        reverse
      />

      <TabsCard
        title="Mais flexibilidade para escalar o seu negócio"
        description="Soluções para todos os tamanhos e modelos de negócio. Do pequeno ao grande, ajudamos a automatizar seus processos e otimizar seus custos."
        // className="[&>p]:mb-0 [&>p]:md:mb-0 [&_#image-container-tabscard]:max-md:min-h-0 [&_#image-container-tabscard_img]:max-md:h-[240px] [&_#tabs-container-tabscard]:max-md:mx-0 [&_#tabs-container-tabscard]:max-md:bg-display-100  [&_#tabs-container-tabscard]:max-md:w-full  [&_#tabs-container-tabscard]:max-md:justify-center"
        tabs={[
          {
            title: 'Descomplique suas vendas online',
            description:
              'Solução pronta para vender de forma simples e segura, com integração direta com as principais plataformas de e-commerce. É só integrar e começar a vender!',
            desktopImage: {
              alt: 'Imagem de uma pessoa segurando uma maquininha de cartão',
              src: Card2Desktop,
            },
            tabletImage: {
              alt: 'Imagem de uma pessoa segurando uma maquininha de cartão',
              src: Card2Tablet,
            },
            mobileImage: {
              alt: 'Imagem de uma pessoa segurando uma maquininha de cartão',
              src: Card2Mobile,
            },
            label: 'Pronto para usar',
            buttons: [
              {
                children: 'Comece agora',
                linkHref: '/ofertas',
                className: 'w-full',
              },
            ],
          },
          {
            title: 'Maior autonomia para seu fluxo de pagamentos',
            description:
              'Conecte seu negócio a múltiplas adquirentes e conte com antifraude personalizável e retentativa online — tudo em uma única integração via API.',
            desktopImage: {
              alt: 'Imagem de uma pessoa segurando uma maquininha de cartão',
              src: Card1Desktop,
            },
            tabletImage: {
              alt: 'Imagem de uma pessoa segurando uma maquininha de cartão',
              src: Card1Tablet,
            },
            mobileImage: {
              alt: 'Imagem de uma pessoa segurando uma maquininha de cartão',
              src: Card1Desktop,
            },
            label: 'Customizado',
            buttons: [
              {
                children: 'Fale com um especialista',
                linkHref: '/ofertas',
                className: 'w-full',
              },
            ],
          },
        ]}
      />

      <SimpleCard
        title="Controle suas vendas em tempo real"
        backgroundColor="[&>div:nth-of-type(2)]:md:w-[357px] [&>div:nth-of-type(2)>p]:md:w-[357px] [&>div:nth-of-type(2)]:md:w-full [&>div:nth-of-type(2)>p]:md:w-full"
        description="Acompanhe vendas, saldos e repasses com transparência e facilidade. Centralize sua gestão financeira e tome decisões mais estratégicas para seu negócio."
        iconDescriptions={[
          {
            text: 'Consulte valores e prazos de recebimento',
            iconName: 'PagarmeCheck',
          },
          {
            text: 'Visualize taxas e motivos de recusa',
            iconName: 'PagarmeCheck',
          },
          {
            text: 'Extraia relatórios personalizados',
            iconName: 'PagarmeCheck',
          },
          {
            text: 'Realize estornos e gerencie chargebacks',
            iconName: 'PagarmeCheck',
          },
          {
            text: 'Antecipe seus recebíveis',
            iconName: 'PagarmeCheck',
          },
        ]}
        image={{
          alternativeText: 'Imagem ABF',
          path: SellsRealTime,
        }}
        buttons={[
          {
            children: 'Cadastre-se já',
            variant: 'primary',
            linkHref: '/ofertas',
          },
        ]}
      />
      <div
        className={`
          md:mx-32 [&_#card-container-section-rotate]:max-md:max-h-none
          [&>div>div>div:nth-of-type(1)]:lg:w-full
        
          [&>div>div>div:nth-of-type(1)>div>p]:lg:w-[680px]
          [&>div>div>div:nth-of-type(1)>div>h2]:sm:md:w-full
          [&>div>div>div:nth-of-type(1)>div>h2]:text-3xl
          [&>div>div>div:nth-of-type(1)>div>h2]:lg:text-4xl
          [&_h5]:text-lg [&_h5]:leading-4 [&_h5]:lg:text-xl [&_h5]:lg:leading-5
          [&>div>div>div:nth-of-type(2)>div]:p-24 [&>div>div>div:nth-of-type(2)>div]:lg:p-40
          [&>div>div>div:nth-of-type(2)>div>div>p]:text-base [&>div>div>div:nth-of-type(2)>div>div>p]:leading-[26px]
          [&>div>div>div:nth-of-type(2)>div>div>p]:lg:leading-[30px]
        `}
      >
        <SectionRotate
          title="Alta performance e segurança"
          description="Nossa tecnologia segue os mais rigorosos padrões do mercado de pagamentos, para garantir estabilidade e segurança de ponta a ponta para o seu negócio."
          id={1}
          referId="referencia-unica"
          analyticsReference="stone-experiencia"
          buttons={[]}
          cards={[
            {
              title: 'PCI Compliance',
              description:
                'O Pagar.me é certificado pelo PCI DSS Nível 1, protegendo os dados sensíveis dos seus clientes.',
              images: {
                mobile: {
                  path: Compliance,
                },
                tablet: {
                  path: Compliance,
                },
                web: {
                  path: Compliance,
                },
              },
            },
            {
              title: 'Estabilidade transacional',
              description: 'Infraestrutura capaz de processar milhares de transações por segundo.',
              images: {
                mobile: {
                  path: Dashboard,
                },
                tablet: {
                  path: Dashboard,
                },
                web: {
                  path: Dashboard,
                },
              },
            },
            {
              title: 'Proteção antifraude',
              description: 'Conte com sistema antifraude e autenticação 3DS 2.0 para proteger suas vendas.',
              images: {
                mobile: {
                  path: Antifraude,
                },
                tablet: {
                  path: Antifraude,
                },
                web: {
                  path: Antifraude,
                },
              },
            },
          ]}
        />
      </div>
      <SimpleCard
        title="Atendimento humano de verdade"
        description="Fale com um time especializado e pronto para te ajudar, em segundos. Aqui, você é atendido por pessoas que entendem do seu negócio e te ajudam com agilidade e eficiência."
        iconDescriptions={[]}
        image={{
          alternativeText: 'Imagem ABF',
          path: Humanity,
        }}
        buttons={[
          {
            children: 'Cadastre-se agora',
            variant: 'primary',
            linkHref: '/ofertas',
          },
        ]}
      />
      <SimpleCard
        title="Fácil implementação"
        description={`Além de integração com as principais plataformas do mercado, o Pagar.me tem uma documentação detalhada e SDKs para você implementar nossa API com facilidade. <a class="text-stone-500 underline" href='https://docs.pagar.me' target="_blank">Confira a documentação<a/>`}
        iconDescriptions={[]}
        image={{
          alternativeText: 'Imagem ABF',
          path: PagarmeIntegracao,
        }}
        buttons={[
          {
            children: 'Quero começar',
            variant: 'primary',
            linkHref: '/ofertas',
          },
        ]}
        reverse
      />
      <CardBanner
        tag="Stone para quem vende online"
        title="O Pagar.me é a tecnologia de pagamentos digitais da Stone"
        backgroundColor="bg-display-100 [&_picture>img]:object-contain"
        description="Feita para facilitar a vida do empreendedor brasileiro e impulsionar suas vendas online."
        unlimitedImageSize
        buttons={[
          {
            children: 'Conheça o Pagar.me',
            linkHref: '/sobre',
          },
        ]}
        images={{
          mobile: {
            alternativeText: 'Maquininhas',
            path: DigitalPayment,
          },
          tablet: {
            alternativeText: 'Maquininhas',
            path: DigitalPayment,
          },
          web: {
            alternativeText: 'Maquininhas',
            path: DigitalPayment,
          },
        }}
      />
      <div className="[&>div>div>div>div>div>div>div>div>div>picture]:hidden [&>div>div>div>div>div>div>div>div:nth-of-type(1)>p]:font-display [&_h3]:self-center">
        <Assessments
          testimonials={{
            id: 1,
            title: (
              <>
                A opinião de quem usa <br />e recomenda:
              </>
            ),
            description: '',
            referId: 'testimonials-section',
            assessment: {
              imageRepetable: [
                {
                  id: 1,
                  image: {
                    alt: 'Certificado RA1000 Reclame Aqui',
                    src: 'https://assets.decocache.com/payme/002ab32a-6fa2-424c-8838-834f73cd34eb/Frame-1000003738.png',
                    width: 134,
                  },
                },
                {
                  id: 2,
                  image: {
                    alt: 'Nota Reclame Aqui 9.5',
                    src: 'https://assets.decocache.com/payme/202c402a-260d-4f67-8d93-052441d16bd1/1.svg',
                  },
                },
              ],
            },
            testimonialsCard: [
              {
                id: 1,
                image: { alt: '', src: '' },
                name: (
                  <>
                    Luisa Dias
                    <p className="font-sans text-base font-normal mt-[4px]">Founder Loja Criare</p>
                  </>
                ),
                profile: 'Founder Loja Criare',
                testimonial:
                  '“Mudei recentemente para o Pagar.me e estou encantada com tudo! A interface é bem melhor que a de outros sistemas que já utilizei, fácil de mexer, mais completa e o atendimento é impecável. Estou muito satisfeita e recomendo a todos!”',
              },
              {
                id: 2,
                image: { alt: '', src: '' },
                name: (
                  <>
                    Luis Otávio Ribeiro
                    <p className="font-sans text-base font-normal mt-[4px]">Co-founder Cartase</p>
                  </>
                ),
                profile: 'Co-founder Cartase',
                testimonial:
                  '“A eficiência do Pagar.me facilita a vida de milhares de pessoas que realizam projetos incríveis no Catarse.”',
              },
              {
                id: 3,
                image: { alt: '', src: '' },
                name: (
                  <>
                    Marcio Acorci
                    <p className="font-sans text-base font-normal mt-[4px]">Co-founder & CEO Wedy</p>
                  </>
                ),
                profile: 'Co-founder & CEO Wedy',
                testimonial:
                  '“Além de mais que triplicar as taxas de conversão em compras, toda a tecnologia permitiu de forma muito simples que pudéssemos escalar o nosso negócio sem nos preocupar com a plataforma de pagamento.”',
              },
              {
                id: 4,
                image: { alt: '', src: '' },
                name: (
                  <>
                    Bruno Mozer
                    <p className="font-sans text-base font-normal mt-[4px]">Founder Click Sophia</p>
                  </>
                ),
                profile: 'Founder Click Sophia',
                testimonial:
                  '“O Pagar.me tem sido uma parte crucial da nossa operação oferecendo um serviço excepcional com um dashboard incrível.”',
              },
            ],
          }}
        />
      </div>
    </Layout>
  );
};

export default Home;
